import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SeoService } from '../../core/services/seo.service';
import { LegalLayoutComponent } from './legal-layout.component';

/**
 * Bewertungs-Richtlinien (Spec § 8.1, § 8.2, § 8.3).
 * Verlinkt im Footer + im Bewertungs-Modal — zentrale Compliance-Seite.
 */
@Component({
  selector: 'app-bewertungs-richtlinien',
  standalone: true,
  imports: [LegalLayoutComponent, RouterLink],
  templateUrl: './bewertungs-richtlinien.component.html',
})
export class BewertungsRichtlinienComponent {
  constructor() {
    inject(SeoService).apply({
      title: 'Bewertungs-Richtlinien · Craftly',
      description:
        'So funktionieren Bewertungen auf Craftly: anonym, double-blind, '
          + 'ab 3 Bewertungen sichtbar, ohne Incentivierung. § 5b UWG, DSGVO, DSA.',
      path: '/bewertungs-richtlinien',
      type: 'article',
    });
  }
}
